let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3Tt7n")).then(() => parcelRequire('1kvGh'));